import React from "react";
import styled from "styled-components";

type TextMoreButtonProps = {
	onClick?: (e?: React.FormEvent<HTMLButtonElement>) => void;
	isShow?: boolean;
};

const Button = styled.button<{$isActive: boolean}>`
	position: relative;
	display: inline-block;
	padding-right: 20px;
	background-color: #fff;
	font-size: var(--basic-size);
	font-family: "PT-regular";
	color: var(--default-color);
	line-height: 1;

	&:after {
		display: inline-block;
		position: absolute;
		top: ${props => (props.$isActive ? "5px" : "1px")};
		right: 2px;
		width: 7px;
		height: 7px;
		border-top: 1px solid var(--default-color);
		border-left: 1px solid var(--default-color);
		transform: ${props => (props.$isActive ? "rotate(45deg)" : "rotate(225deg)")};
		content: "";
	}
`;

const TextMoreButton = ({onClick, isShow}: TextMoreButtonProps) => (
	<Button onClick={onClick} $isActive={isShow}>
		{isShow ? "접기" : "더보기"}
	</Button>
);

export default TextMoreButton;
